export const API_URL = "https://forkify-api.jonas.io/api/v2/recipes/";
export const TIMEOUT_SECONDS = 3000;
export const RESULTS_PER_PAGE = 10;
export const KEY = "53305b10-f859-4fce-b084-ce47dddab63b";
export const MODAL_CLOSE_SEC = 1;
